import script from "./MobileView.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileView.vue?vue&type=script&setup=true&lang=js"

import "./MobileView.vue?vue&type=style&index=0&id=32074532&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32074532"]])

export default __exports__